import * as _ from 'lodash';

export default {
  props: ['value', 'options', 'fieldValue', 'fieldCaption'],

  data() {
    return {
      currentValue: this.value
    }
  },

  watch:{
    value: function(newVal){
      this.currentValue = newVal
      this.selectItem(this.selected)
    }
  },

  computed:{
    selected: function(){
      return _.find(this.options, o => {
        if(!o)
          return false
        return this.getItemValue(o) == this.currentValue
      });
    }
  },

  mounted(){
    if(this.value)
      this.currentValue = this.value;

    this.$emit('input', this.currentValue);
    this.$emit('itemSelected', this.selected);
  },

  methods: {
    selectItem(item) {
      if(item && this.getItemValue(item) != this.currentValue){
        this.currentValue = this.getItemValue(item);
        this.$emit('input', this.getItemValue(item));
        this.$emit('itemSelected', item);
      }
    },

    getItemValue(item){
      if(this.fieldValue){
        return item[this.fieldValue];
      }
      return item.value;
    },

    getItemCaption(item){
      if(this.fieldCaption){
        return item[this.fieldCaption];
      }
      return item.caption;
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/dropdown/dropdown.js